import request from './axios';

/**
 * 获取文档列表
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页条数
 * @param {Number} params.category 分类ID
 * @param {String} params.exclude 排除的文档ID
 * @param {Number} params.limit 限制条数
 * @returns {Promise<Object>} 返回文档列表和总数
 */
export function getDocsList(params) {
  return request({
    url: '/webapi/docs/list',
    method: 'get',
    params
  });
}

/**
 * 获取文档详情
 * @param {String} id 文档ID
 * @returns {Promise<Object>} 返回文档详情
 */
export function getDocsDetail(id) {
  return request({
    url: `/webapi/docs/detail/${id}`,
    method: 'get'
  });
}

/**
 * 获取文档分类
 * @returns {Promise<Object>} 返回文档分类列表
 */
export function getDocsCategories() {
  return request({
    url: '/webapi/docs/categories',
    method: 'get'
  });
}

/**
 * 获取热门文档
 * @param {Object} params 查询参数
 * @param {Number} params.limit 限制条数
 * @param {Number} params.category 分类ID
 * @returns {Promise<Object>} 返回热门文档列表
 */
export function getHotDocs(params) {
  return request({
    url: '/webapi/docs/hot',
    method: 'get',
    params
  });
} 